export class JurisdictionsList {
  jurisdictions:jurisdictionType[]
  constructor() {
    this.jurisdictions = [];
  }
}
export interface jurisdictionType {
  id: 1,
  title: string,
  isActive: boolean,
  createdDateTime: string,
  updatedDateTime: string
}

